import { ANALYTICS_EMAIL_TRENDS, ANALYTICS_CLICK_TRENDS } from "constants/types";

const initialAnalyticsEmailTrends = {
  loading: false,
  title: "",
  zoomLevel: [],
  zoomLevelIndex: 0,
  daily: {
    yAxis: {},
    xAxis: [],
  },
  weekly: {
    yAxis: {},
    xAxis: [],
  },
  quarterly: {
    yAxis: {},
    xAxis: [],
  },
  monthly: {
    yAxis: {},
    xAxis: [],
  },
  yearly: {
    yAxis: {},
    xAxis: [],
  },
};
const initialAnalyticsClickTrends = {
  loading: false,
  title: "",
  zoomLevelIndex: 0,
  zoomLevel: [],
  daily: {
    yAxis: {},
    xAxis: [],
  },
  weekly: {
    yAxis: {},
    xAxis: [],
  },
  quarterly: {
    yAxis: {},
    xAxis: [],
  },
  monthly: {
    yAxis: {},
    xAxis: [],
  },
  yearly: {
    yAxis: {},
    xAxis: [],
  },
};

export const analyticsEmailTrendsReducer = (state: any = initialAnalyticsEmailTrends, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case ANALYTICS_EMAIL_TRENDS.LOAD:
      newState.loading = true;
      return newState;
    case ANALYTICS_EMAIL_TRENDS.LOAD_SUCCESS:
      newState.loading = false;
      newState.title = action.payload.title;
      newState.zoomLevel = action.payload.zoom_level;
      newState.zoomLevelIndex = action.payload.zoom_level.length - 1;
      newState.zoomLevelIndex =
        newState.zoomLevel[newState.zoomLevelIndex] === "quarterly" && newState.zoomLevel.length === 4
          ? newState.zoomLevelIndex - 1
          : newState.zoomLevelIndex;
      newState.daily = {
        yAxis: action.payload.daily_plot_data.data,
        xAxis: [...action.payload.daily_plot_data.x_axis],
      };
      newState.weekly = {
        yAxis: action.payload.weekly_plot_data.data,
        xAxis: [...action.payload.weekly_plot_data.x_axis],
      };
      newState.quarterly = {
        yAxis: action.payload.quarterly_plot_data.data,
        xAxis: [...action.payload.quarterly_plot_data.x_axis],
      };
      newState.monthly = {
        yAxis: action.payload.monthly_plot_data.data,
        xAxis: [...action.payload.monthly_plot_data.x_axis],
      };
      newState.yearly = {
        yAxis: action.payload.yearly_plot_data.data,
        xAxis: [...action.payload.yearly_plot_data.x_axis],
      };

      return newState;
    case ANALYTICS_EMAIL_TRENDS.LOAD_FAIL:
      return initialAnalyticsEmailTrends;
    case ANALYTICS_EMAIL_TRENDS.UPDATE_ZOOMLEVEL:
      newState.zoomLevelIndex = action.payload;
      return newState;
    case ANALYTICS_EMAIL_TRENDS.RESET:
      return initialAnalyticsEmailTrends;
    default:
      return newState;
  }
};
export const analyticsClickTrendsReducer = (state: any = initialAnalyticsClickTrends, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case ANALYTICS_CLICK_TRENDS.LOAD:
      newState.loading = true;
      return newState;
    case ANALYTICS_CLICK_TRENDS.LOAD_SUCCESS:
      newState.loading = false;
      newState.title = action.payload.title;
      newState.zoomLevel = action.payload.zoom_level;
      newState.zoomLevelIndex = action.payload.zoom_level.length - 1;
      newState.zoomLevelIndex =
        newState.zoomLevel[newState.zoomLevelIndex] === "quarterly" && newState.zoomLevel.length === 4
          ? newState.zoomLevelIndex - 1
          : newState.zoomLevelIndex;
      newState.daily = {
        yAxis: action.payload.daily_plot_data.data,
        xAxis: [...action.payload.daily_plot_data.x_axis],
      };
      newState.weekly = {
        yAxis: action.payload.weekly_plot_data.data,
        xAxis: [...action.payload.weekly_plot_data.x_axis],
      };
      newState.monthly = {
        yAxis: action.payload.monthly_plot_data.data,
        xAxis: [...action.payload.monthly_plot_data.x_axis],
      };
      newState.quarterly = {
        yAxis: action.payload.quarterly_plot_data.data,
        xAxis: [...action.payload.quarterly_plot_data.x_axis],
      };
      newState.yearly = {
        yAxis: action.payload.yearly_plot_data.data,
        xAxis: [...action.payload.yearly_plot_data.x_axis],
      };
      return newState;

    case ANALYTICS_CLICK_TRENDS.LOAD_FAIL:
      return initialAnalyticsClickTrends;

    case ANALYTICS_CLICK_TRENDS.UPDATE_ZOOMLEVEL:
      newState.zoomLevelIndex = action.payload;
      return newState;
    case ANALYTICS_CLICK_TRENDS.RESET:
      return initialAnalyticsClickTrends;

    default:
      return newState;
  }
};
